
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { FilterName } from '@/stores/filter.store';
import { TabType } from '@/interfaces/inner-tabs';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

const Filter = namespace('filter');

@Component({
	name: 'WatchlistInnerTabNavigation',
	components: { HiddenHorizontalScrollbar },
})
export default class WatchlistInnerTabNavigation extends Vue {
	@Prop({ required: true }) tabs: {
		key: TabType;
		translation: string;
	}[];
	@Prop({ required: true }) selectedTab: TabType;

	@Filter.Action setFilterValue: (payload: {
		filterName: FilterName;
		filterValue: any;
		updateRouteState: boolean;
	}) => void;

	@Emit('scrollToTop')
	scrollToTop() {}

	isActiveTab(tab: TabType) {
		return tab === this.selectedTab;
	}

	onTabClick(tab: TabType) {
		this.$router.replace({ query: { ...this.$route.query, inner_tab: tab, list_id: undefined } });
		this.setFilterValue({
			filterName: 'inner_tab',
			filterValue: tab,
			updateRouteState: false,
		});
		this.scrollToTop();

		TrackingHelper.trackEvent('userinteraction', {
			action: 'filter_toggled',
			label: 'list_types',
			property: tab,
		});
	}
}
